import { TransitionData, TransitionShiftData } from './transition-data';

export function getCarbonAbatement(transitionData: TransitionData): number {
  return (<TransitionShiftData>transitionData).carbonAbatement.net ?? transitionData.carbonAbatement.gross;
}
